module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school",
    style: (_vm.bannerFlag ? 'margin-top: 45px;' : '')
  }, [_c('div', {
    staticClass: "container w"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "calc(100vh - 125px)"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [(_vm.newsList.length > 0) ? _c('div', {
    staticClass: "school-item",
    staticStyle: {
      "min-height": "calc(100vh - 130px)"
    }
  }, [_c('div', {
    staticClass: "school-box"
  }, _vm._l((_vm.newsList), function(item, i) {
    return _c('school-item', {
      key: i,
      attrs: {
        "msg": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "fill-full"
  }), _vm._v(" "), (_vm.newsList.length > 0 && !_vm.error) ? _c('div', {
    staticClass: "pagination-wrap w"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total,prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.noNews) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)]) : _vm._e()])]), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/no-search.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！暂时还没有资讯\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f84cab","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/School/index.vue
// module id = 625
// module chunks = 0